processScormPlayerData = require("lib/scorm").processScormPlayerData
Base64 = require('js-base64').Base64;

class ScormAttempt
  constructor: (lessonId, lessonCompleted, userName, userId, previousAttempt) ->
    @lessonId        = lessonId
    @lessonCompleted = lessonCompleted
    @userName        = userName
    @previousAttempt = previousAttempt
    @userId          = userId
   
  initialData: ->
    if @previousAttempt
      _.extend(@previousAttempt, {
        "cmi.core.student_name": {
          value: @userName
          status: 0
        },
        "cmi.core.student_id": {
          value: @userId
          status: 0
        },
        "cmi.core.lesson_status": {
        value: if @lessonCompleted then "completed" else "incomplete"
        status: 0
        }
      })
    else
      "ed":
        "lessonId": @lessonId
      "cmi.core.lesson_status":
        value: if @lessonCompleted then "completed" else "not attempted"
        status: 0
      "cmi.core.student_name":
        value: @userName
        status: 0
      "cmi.core.student_id":
        value: @userId
        status: 0

  processScormPlayerData: (data) ->
    parsedData = JSON.parse(Base64.decode(data))
    @data = processScormPlayerData(parsedData).all()

  attemptData: ->
    @data


module.exports = ScormAttempt
